import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Truck } from "lucide-react";
import { Logo } from "@/components/Logo";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Programs", to: "/programs" },
  { label: "Schedule an Appointment", to: "/schedule" },
  { label: "Contact", to: "/contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (to) => location.pathname === to;

  return (
    <header className="sticky top-0 z-50 bg-navy/95 backdrop-blur-md border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="header-logo-link">
            <span className="bg-white rounded-md px-2 py-1 flex items-center">
              <Logo className="h-10" />
            </span>
            <span className="hidden 2xl:block text-white font-display font-bold leading-tight text-sm">
              Driven Together<br /><span className="text-magenta">Education Program</span>
            </span>
          </Link>

          <nav className="hidden xl:flex items-center gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-2.5 py-2 rounded-md text-sm whitespace-nowrap font-semibold transition-colors ${
                  isActive(l.to) ? "text-magenta" : "text-white/85 hover:text-white"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <a href="https://www.aawta.org" target="_blank" rel="noopener noreferrer"
               data-testid="nav-aawta-website"
               className="px-2.5 py-2 rounded-md text-sm whitespace-nowrap font-semibold text-white/85 hover:text-white transition-colors">
              AAWTA Website
            </a>
            <Link to="/student/login" data-testid="nav-student-login"
                  className="px-2.5 py-2 rounded-md text-sm whitespace-nowrap font-bold text-magenta border border-magenta/60 hover:bg-magenta hover:text-white transition-colors">
              Student Login
            </Link>
            <Link to="/admin/login" data-testid="nav-admin-login"
                  className="px-2.5 py-2 rounded-md text-sm whitespace-nowrap font-semibold text-white/90 hover:text-magenta transition-colors">
              Admin Login
            </Link>
            <button
              onClick={() => navigate("/intake")}
              data-testid="nav-start-intake"
              className="ml-2 whitespace-nowrap inline-flex items-center gap-2 bg-magenta hover:bg-magenta-dark text-white font-bold text-sm py-2.5 px-5 rounded-md transition-colors"
            >
              <Truck size={16} /> Start Your Intake
            </button>
          </nav>

          <button className="xl:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-navy border-t border-white/10 px-4 py-4 space-y-1" data-testid="mobile-menu">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                  className={`block px-3 py-2.5 rounded-md text-sm font-semibold ${isActive(l.to) ? "text-magenta" : "text-white/85"}`}>
              {l.label}
            </Link>
          ))}
          <a href="https://www.aawta.org" target="_blank" rel="noopener noreferrer" className="block px-3 py-2.5 text-sm font-semibold text-white/85">AAWTA Website</a>
          <Link to="/student/login" onClick={() => setOpen(false)} data-testid="mobile-nav-student-login" className="block px-3 py-2.5 text-sm font-bold text-magenta">Student Login</Link>
          <Link to="/admin/login" onClick={() => setOpen(false)} data-testid="mobile-nav-admin-login" className="block px-3 py-2.5 text-sm font-semibold text-white/90">Admin Login</Link>
          <button onClick={() => { setOpen(false); navigate("/intake"); }}
                  className="w-full mt-2 bg-magenta text-white font-bold py-2.5 px-5 rounded-md">Start Your Intake</button>
        </div>
      )}
    </header>
  );
};
